import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../environments/environment';
import { AlarmNotificationConfigElement as AlarmNotificationConfigElement } from '../models/alarm-notification-config.model';


const API_URL = environment.API_URL

@Injectable({
  providedIn: 'root'
})
export class AlarmConfigService {


  constructor(
    private http: HttpClient
  ) { }

    getAlarmConfig(parent_type: string, parent_id: number): Observable<any> {
      const API_URL_ALARM = `${API_URL}/alarmConfig/${parent_type}/${parent_id}`;
      return this.http.get<AlarmNotificationConfigElement[]>(`${API_URL_ALARM}`);
    }

    insertOrUpdateAlarm(alarm: AlarmNotificationConfigElement): Observable<any> {
      let parentType = alarm.parent_type;
      let parentId = alarm.parent_id;
      const API_URL_ALARM = `${API_URL}/alarmConfig/${parentType}/${parentId}`;
      return this.http.put<AlarmNotificationConfigElement[]>(`${API_URL_ALARM}`, alarm);
    }

    deleteAlarmConfig(parentType: string, parentId: number): Observable<any> {
      const API_URL_ALARM = `${API_URL}/alarmConfig`;
      return this.http.delete<AlarmNotificationConfigElement[]>(`${API_URL_ALARM}/${parentType}/${parentId}`);
    }

}
